<template>
  <div>
    <b-form-group
      id="overridePopover"
      label-for="override-amount"
      label="Override Amount"
    >
      <b-form-input
        id="override-amount"
        v-model="amount"
        data-cy="override-amount"
      />
    </b-form-group>
    <b-popover
      title="Payment Testing"
      direction="left"
      triggers="focus hover"
      placement="left"
      target="overridePopover"
    >
      <p>Override the Transaction Amount for Testing Purposes.</p>
      <p>
        Changing the <em>cents</em> of the transaction total allows for the tesing of different
        payment API responses. Use the below table to determine the errors returned for the different
        override amounts.
      </p>

      <ul>
        <li><strong>Approved</strong> - 00 and all other amounts not listed below</li>
        <li><strong>Invalid Card</strong> - 31</li>
        <li><strong>Expired Card</strong> - 54</li>
        <li><strong>Declined</strong> - 51</li>
        <li><strong>Insufficient Funds</strong> - 61</li>
        <li><strong>Technical Failure</strong> - 96</li>
      </ul>
    </b-popover>
  </div>
</template>

<script>
export default {
  name: 'integrapay-payment-testing',
  props: {
    value: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    amount: {
      get() {
        let val = parseFloat(this.value).toFixed(2)
        if (!isNaN(val)) {
          return this.value
        }
        else {
          return ''
        }
      },
      set(value) {
        let val = parseFloat(value).toFixed(2)
        if (!isNaN(val)) {
          this.$emit('input', value)
        }
        else {
          this.$emit('input', '')
        }
      }
    }
  }
}
</script>
